import React from "react";

import type { NoteEdgesType, StreamUsersType } from "~/stream/types";

export const StreamContentContext = React.createContext<NoteEdgesType>([]);
StreamContentContext.displayName = "StreamContentContext";
export const StreamUsersContext = React.createContext<StreamUsersType>([]);
StreamUsersContext.displayName = "StreamUsersContext";
export const BlockTypeContext = React.createContext({ blockTypes: {} });
BlockTypeContext.displayName = "BlockTypeContext";
export const AttendeesContext = React.createContext([]);
AttendeesContext.displayName = "AttendeesContext";
export const SelectionStateContext = React.createContext(null);
SelectionStateContext.displayName = "SelectionStateContext";
